import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import PageHeader from '../components/PageHeader';
import WatermarkEncodeLibrary from './WatermarkEncodeLibrary';
import DCPLibrary from './DCPLibrary';

function Library() {
  const { activeProduct } = useSelector((state) => state.company);
  const isDCP = activeProduct === 'theatrical_dcp';

  return (
    <Box>
      {/* Watermarks has no catalog/distribution split — every encode is
          per-recipient, so this page IS the Distribution view. DCP keeps
          a separate Library (catalog) and Distribution (recipients)
          because one DCP fans out to many venues. */}
      <PageHeader
        title={isDCP ? 'Library' : 'Distribution'}
        subtitle={isDCP
          ? 'Completed DCP packages — open Distribution to send and manage KDMs'
          : 'Per-recipient watermark encodes, deliveries, comments, and analytics'}
      />
      {isDCP ? <DCPLibrary /> : <WatermarkEncodeLibrary />}
    </Box>
  );
}

export default Library;
